<template>
    <section>
        <m-art-edit :form.sync="form" :form-rules="rules" :submit-success-func="submitSuccessFunc" :submit-func="submitFunc" label-width="130px" :reset-form-callback="resetFunc">
            <template v-slot:form-items>
                <m-card title="添加关键词组">
                    <el-row :gutter="24">
                        <el-col :span="24">
                            <el-form-item label="关键词组名称" prop="keywordGroupName">
                                <el-input v-model.trim="form.keywordGroupName" placeholder="客诉关键词分类" style="width:220px;" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="工单分类" prop="qaTypeId">
                                <el-select v-model="form.qaTypeId" placeholder="工单分类" @change="handleChangeType" style="width:220px;">
                                    <el-option v-for="(item, index) in workCutList" :key="index" :value="item.parentTypeId" :label="item.parentQaTypeName"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="关键词" prop="keywordDtos">
                                <el-table :data="form.keywordDtos" border>
                                    <el-table-column label="关键词名称">
                                        <template v-slot="{$index,row}">
                                            <div v-if="row.isEdit" class="tags">
                                                <el-tag size="small" :key="i" v-for="(tag,i) in row.keywords" closable :disable-transitions="false" @close="handleClose(i,row.keywords)">
                                                    {{tag}}
                                                </el-tag>
                                                <el-input class="input-new-tag" :ref="`saveInput${$index}`" v-if="row.inputVisible" v-model="row.inputValue" size="small" @keyup.enter.native="handleInputConfirm(row)">
                                                </el-input>
                                                <el-button v-else class="button-new-tag" size="small" @click="showInput(row,$index)">+</el-button>
                                            </div>
                                            <div v-else>{{row.keywords.join(',')}}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="对应工单问题" width="160">
                                        <template v-slot="{row}">
                                            <el-select v-model="row.qaTypeId" placeholder="" :disabled="!row.isEdit||!form.qaTypeId" @change="(v)=>handleChangeTypeRow(v,row)">
                                                <el-option v-for="(item, index) in workTypeList" :key="index" :value="item.qaTypeId" :label="item.qaTypeName">
                                                    <span style="float: left">{{ item.qaTypeName }}</span>
                                                    <span style="float: right">
                                                        <el-tooltip class="item" effect="dark" :content="item.qaTypeDesc">
                                                            <i class="el-icon-info"></i>
                                                        </el-tooltip>
                                                    </span>
                                                </el-option>
                                            </el-select>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="是否启用" width="120">
                                        <template v-slot="{row}">
                                            <el-switch v-model="row.status" :disabled="!row.isEdit" active-value="Enable" inactive-value="Disable"></el-switch>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="匹配方式" width="160">
                                        <template v-slot="{row}">
                                            <el-select v-model="row.minimumNum" placeholder="未选择" :disabled="!row.isEdit">
                                                <el-option v-for="item in row.keywords.length" :key="item" :value="item" :label="item===row.keywords.length?'全部匹配':`匹配${item}个`"></el-option>
                                            </el-select>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="优先级" width="150">
                                        <template v-slot="{row}">
                                            <el-input type="number" v-model.number="row.priority" :min="0" :max="999" placeholder="数字越小优先级越高" :disabled="!row.isEdit"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="标签备注" width="150">
                                        <template v-slot="{row}">
                                            <el-input v-model="row.keywordRemark" placeholder="" :disabled="!row.isEdit"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作" width="100">
                                        <template v-slot="{$index}">
                                            <el-button type="text" @click="removeColumn($index)">删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <el-button type="primary" size="small" @click="addColumn">新增关键词</el-button>
                            </el-form-item>
                            <el-form-item label="备注" prop="keywordGroupRemark">
                                <el-input v-model.trim="form.keywordGroupRemark" :maxlength="512" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="是否启用" prop="status">
                                <el-switch v-model="form.status" active-value="Enable" inactive-value="Disable"></el-switch>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </m-card>
            </template>
        </m-art-edit>
    </section>
</template>

<script>
import api from "plus/api";
import detailsMixin from "@/mixin/detailsMixin";
export default {
    name: "privilege.keywords.details",
    mixins: [detailsMixin],
    data() {
        return {
            parentMenus: [],
            form: {
                keywordGroupName: "",
                qaTypeId: "",
                keywordDtos: [],
                keywordGroupRemark: "",
                status: "Disable",
                qaTypeName: "",
            },
            rules: {
                keywordGroupName: [
                    { required: true, message: "请填写关键词组名称" },
                ],
                qaTypeId: [{ required: true, message: "请选择工单分类" }],
                keywordDtos: [
                    { required: true, message: "请填写关键词" },
                    {
                        type: "array",
                        required: true,
                        min: 1,
                        defaultField: {
                            type: "object",
                            required: true,
                            fields: {
                                keywords: {
                                    type: "array",
                                    required: true,
                                    min: 1,
                                    message: "关键词不能为空",
                                },
                                qaTypeId: {
                                    type: "string",
                                    required: true,
                                    message: "请选择对应问题",
                                },
                                minimumNum: {
                                    type: "number",
                                    required: true,
                                    message: "请选择匹配方式",
                                },
                                priority: [
                                    {
                                        type: "number",
                                        min: 0,
                                        max: 999,
                                        message: "优先级范围错误",
                                    },
                                ],
                            },
                        },
                        message: "关键词不能为空",
                    },
                ],
            },
            workCutList: [],
            workTypeList: [],
        };
    },
    created() {
        api.dropDownList.getWorkCut().then((res) => {
            this.workCutList = res.data.data;
        });
        if (this.isEdit) {
            this.getInfo();
        }
    },
    methods: {
        getInfo() {
            api.keywords.getInfo(this.$route.query).then((res) => {
                const data = res.data.data;
                data.keywordDtos.forEach((item) => {
                    item.isEdit = true;
                    item.inputValue = "";
                    item.inputVisible = false;
                });
                this.form = data;
                api.dropDownList
                    .getWorkType({
                        id: this.form.qaTypeId,
                    })
                    .then((res) => {
                        this.workTypeList = res.data.data;
                    });
            });
        },
        resetFunc() {
            if (this.isEdit) {
                this.getInfo();
            }
        },
        submitFunc(params) {
            params.keywordDtos = params.keywordDtos.map((item) => {
                const { inputValue, inputVisible, isEdit, ...obj } = item;
                if (obj.minimumNum > obj.keywords.length) {
                    obj.minimumNum = obj.keywords.length;
                }
                return obj;
            });
            if (this.isEdit) {
                params.id = this.$route.query.id;
                return api.keywords.editById(params);
            } else {
                return api.keywords.create(params);
            }
        },
        submitSuccessFunc() {
            this.$message.success("提交成功");
        },
        handleChangeType(v) {
            const filters = {
                id: v,
            };
            this.form.qaTypeName = this.workCutList.filter(
                (item) => item.parentTypeId === v
            )[0].parentQaTypeName;
            this.form.keywordDtos.forEach((item) => {
                item.qaTypeId = "";
                item.qaTypeName = "";
            });
            api.dropDownList.getWorkType(filters).then((res) => {
                this.workTypeList = res.data.data;
            });
        },
        handleChangeTypeRow(v, row) {
            row.qaTypeName = this.workTypeList.filter(
                (item) => item.qaTypeId === v
            )[0].qaTypeName;
        },
        addColumn() {
            this.form.keywordDtos.push({
                keywordRemark: "",
                keywords: [],
                minimumNum: "",
                priority: 0,
                qaTypeId: "",
                qaTypeName: "",
                status: "Enable",
                isEdit: true,
                inputVisible: false,
                inputValue: "",
            });
        },
        handleClose(index, ks) {
            ks.splice(index, 1);
        },
        showInput(row, index) {
            row.inputVisible = true;
            this.$nextTick(() => {
                this.$refs[`saveInput${index}`].focus();
            });
        },
        handleInputConfirm(row) {
            let inputValue = row.inputValue;
            if (inputValue && !row.keywords.includes(inputValue)) {
                row.keywords.push(inputValue);
            }
            row.inputVisible = false;
            row.inputValue = "";
        },
        removeColumn(index) {
            this.form.keywordDtos.splice(index, 1);
        },
    },
};
</script>
<style lang="less" scoped>
.tags {
    .el-tag + .el-tag {
        margin-left: 10px;
        margin-bottom: 10px;
    }
    .button-new-tag {
        margin-left: 10px;
        height: 24px;
        line-height: 24px;
        padding-top: 0;
        padding-bottom: 0;
    }
    .input-new-tag {
        width: 90px;
        margin-left: 10px;
        vertical-align: bottom;
    }
}
</style>
